// extracted by mini-css-extract-plugin
export default {"table":"UfoTable_table__xmxfL","darkBorder":"UfoTable_darkBorder__IfLHu"};